export enum NavigationTabType {
    INSIGHT = 'insight',
    LIQUIDITY = 'liquidity',
    MESSAGES_CENTER = 'messagesCenter',
    PROFILES = 'profiles',
    RULES = 'rules',
    ARCHIVE = 'archive'
}
